export default __webpack_public_path__ + "static/media/OPDEMRtraining.4b177a05.mp4";